import React, { useEffect, useState } from "react";
import apiProducts from "../../../api/products";
import { useSelector } from "react-redux";
import { Button, Container, Table } from "react-bootstrap";
import TextInput from "../../../components/TextInput/TextInput";
import { PencilSquare, ArrowUpSquareFill } from "react-bootstrap-icons";
import CheckSphere from "../../../components/CheckSphere/CheckSphere";
import PseudoTable from "../../../components/PseudoTable/PseudoTable";

import Spinner from "../../../components/Spinner/Spinner";
import classes from "./ProductsList.module.css";

import handleApiErrors from "../../../utilities/handleApiErrors";
import PaginationItem from "../../../components/PaginationItem/PaginationItem";
import stringSimilarity from "string-similarity";
import useInfiniteScroll from "../../../utilities/useInfiniteScroll";

const states = {
  LOADING: "LOADING",
  LOADED: "LOADED",
  ERROR: "ERROR",
};
const resultsNumber = 20;

const ProductsList = (props) => {
  const accesToken = useSelector((state) => state.user.access);

  const [inputValue, setInputValue] = useState("");
  // const [dataToCompare, setDataToCompare] = useState("");

  const [allProducts, setAllProducts] = useState([]);
  const [allProductsUntouched, setAllProductsUntouched] = useState([]);

  const [process, setProcess] = useState(states.LOADING);

  // States for pagination
  const [pageNumber, setPageNumber] = useState(0);
  // INFINITE SCROLL
  const [results, setResults] = useState(20);
  const [isFetching, setIsFetching] = useInfiniteScroll(fetchMoreListItems);

  //Bring data to make the list of products
  useEffect(() => {
    apiProducts
      .listAll(accesToken)
      .then(({ data }) => {
        const items = data.map((item) => ({
          id: item.id,
          name: item.name,
          active: item.active,
        }));

        setAllProducts(items);
        setAllProductsUntouched(items);
        setProcess(states.LOADED);
      })
      .catch((e) => {
        handleApiErrors(e);
      });
  }, []);
  // * FUNCTION FOR THE SCROLL INFINITE
  function fetchMoreListItems() {
    setTimeout(() => {
      if (results + 20 > allProducts.length) {
        setResults(allProducts.length);
      } else {
        setResults(results + 20);
      }
      setIsFetching(false);
    }, 500);
  }
  // Edit category
  const editProduct = (pId) => {
    props.history.push(`/product/${pId}`);
  };

  // Split arrays function
  const splitArrays = (arr, len) => {
    var chunks = [],
      i = 0,
      n = arr.length;
    while (i < n) {
      chunks.push(arr.slice(i, (i += len)));
    }
    return chunks;
  };

  // * LOGIC FROM SIMILARITY ALGORITHMN
  useEffect(() => {
    const queryedItems = allProducts.map((item) => {
      const scoredItem = {
        ...item,
        score: stringSimilarity.compareTwoStrings(
          inputValue.toLocaleLowerCase(),
          item.name.toLocaleLowerCase()
        ),
      };
      return scoredItem;
    });
    const arrayfilteredSorted = queryedItems.sort((a, b) => {
      if (a.score > b.score) {
        return -1;
      }
      if (a.score < b.score) {
        return 1;
      }
      return 0;
    });

    const exactItems = [];
    const similarItems = [];

    arrayfilteredSorted.forEach((product) => {
      if (product.name.toLocaleLowerCase().includes(inputValue)) {
        exactItems.push(product);
      } else {
        similarItems.push(product);
      }
    });

    // When there are 3 letters or more then it shows the flitered/ordered array, if not the general array
    inputValue.length > 2
      ? setAllProducts([
          ...exactItems,
          ...similarItems.filter((item) => item.score > 0.1),
        ])
      : setAllProducts(allProductsUntouched);
  }, [inputValue]);

  //  * LOGIC FOR RESPONSIVE, IF MATCH WITH THE MOBILE SCREEN THE RESULTS PER PAGE ADD 20 RESULTS AVERY TIME SCROLL TO THE END OF THE VIEWPORT
  let breakPointResponsive = window.matchMedia("(max-width: 65em)");
  let bodyContent;
  function responsiveBreakMatch(breakPointResponsive) {
    // If media query matches, the type of results change to the state
    bodyContent =
      splitArrays(
        allProducts,
        breakPointResponsive.matches ? results : resultsNumber
      )[pageNumber] === undefined
        ? null
        : splitArrays(
            allProducts,
            breakPointResponsive.matches ? results : resultsNumber
          )[pageNumber].map((item, index) => {
            return (
              <>
                {/* <ReactTooltip place="left" type="info" /> */}

                <PseudoTable.Row className={classes.row} key={item.id}>
                  <div>{item.id}</div>
                  <div>
                    <p>{item.name}</p>
                  </div>
                  <div>
                    <CheckSphere check={item.active} x={!item.active} />
                  </div>
                  <div>
                    <Button
                      variant="light"
                      onClick={() => editProduct(item.id)}
                    >
                      <PencilSquare />
                    </Button>
                  </div>
                </PseudoTable.Row>
                {breakPointResponsive.matches && allProducts.length > 20 ? (
                  results <= 20 ? null : (
                    <div className={classes.arrowContainer}>
                      <ArrowUpSquareFill
                        // data-tip="Volver al inicio"
                        className={classes.arrowUp}
                        onClick={() => {
                          window.scrollTo(0, 0);
                        }}
                      />
                    </div>
                  )
                ) : null}
              </>
            );
          });
  }
  responsiveBreakMatch(breakPointResponsive);

  return (
    <>
      {/* Title */}
      <Container className={classes.title}>
        <h1>Lista de productos</h1>
      </Container>

      {/* Input search engine */}
      <Container className={classes.input}>
        <TextInput
          placeholder="Introduce el nombre del producto"
          onChange={(event) => {
            setInputValue(event.target.value);
            setPageNumber(0);
          }}
          value={inputValue}
          // error={errorState}
          // errorMessage="No se ha encontrado ninguna coincidencia"
        />
      </Container>

      {/* Table */}
      <Container>
        {process === "LOADING" ? (
          <Spinner
            className="mt-5"
            as="svg"
            animation="border"
            size="lg"
            role="status"
            aria-hidden="true"
          />
        ) : (
          <>
            {/* PAGINATION */}
            {allProducts.length >= 10 ? (
              <PaginationItem
                //Pongo el mismo array en filtrado para que no cambie la paginación ni de error
                arrayWhole={allProducts}
                resultsNumber={resultsNumber}
                setPageNumber={setPageNumber}
                pageNumber={pageNumber}
                inputValue={inputValue}
              />
            ) : null}

            {/* END OF PAGINATION*/}

            <PseudoTable.Table>
              <PseudoTable.Header className={classes.header}>
                <div>ID</div>
                <div>NOMBRE</div>
                <div>ACTIVO</div>
                <div>EDITAR</div>
              </PseudoTable.Header>
              {bodyContent}
            </PseudoTable.Table>
            {/* //* SPINNER IN MOBILE WHEN LOADING MORE ITEMS */}
            {isFetching ? (
              <div className={classes.hideSpinnerDesktop}>
                <Spinner
                  as="svg"
                  animation="border"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                />
              </div>
            ) : null}
            {/*BOTTOM PAGINATION */}
            {allProducts.length >= 10 ? (
              <PaginationItem
                //Pongo el mismo array en filtrado para que no cambie la paginación ni de error
                arrayWhole={allProducts}
                resultsNumber={resultsNumber}
                setPageNumber={setPageNumber}
                pageNumber={pageNumber}
                inputValue={inputValue}
              />
            ) : null}

            {/* END OF BOTTOM PAGINATION*/}
          </>
        )}
      </Container>
    </>
  );
};

export default ProductsList;
